window.slate = window.slate || {}, window.theme = window.theme || {}, slate.a11y = {
    pageLinkFocus: function(t) {
        var e = "js-focus-hidden";
        t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", function() {
            t.first().removeClass(e).removeAttr("tabindex")
        })
    },
    focusHash: function() {
        var t = window.location.hash;
        t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
    },
    bindInPageLinks: function() {
        $("a[href*=#]").on("click", function(t) {
            this.pageLinkFocus($(t.currentTarget.hash))
        }.bind(this))
    },
    trapFocus: function(t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).on(e, function(e) {
            t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
        })
    },
    removeTrapFocus: function(t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e)
    }
}, slate.cart = {
    cookiesEnabled: function() {
        var t = navigator.cookieEnabled;
        return t || (document.cookie = "testcookie", t = -1 !== document.cookie.indexOf("testcookie")), t
    }
}, slate.utils = {
    findInstance: function(t, e, n) {
        for (var a = 0; a < t.length; a++)
            if (t[a][e] === n) return t[a]
    },
    removeInstance: function(t, e, n) {
        for (var a = t.length; a--;)
            if (t[a][e] === n) {
                t.splice(a, 1);
                break
            } return t
    },
    compact: function(t) {
        for (var e = -1, n = null == t ? 0 : t.length, a = 0, r = []; ++e < n;) {
            var o = t[e];
            o && (r[a++] = o)
        }
        return r
    },
    defaultTo: function(t, e) {
        return null == t || t != t ? e : t
    }
}, slate.rte = {
    wrapTable: function(t) {
        var e = void 0 === t.tableWrapperClass ? "" : t.tableWrapperClass;
        t.$tables.wrap('<div class="' + e + '"></div>')
    }
}, slate.Sections = function() {
    this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:section:reorder", this._onReorder.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(t, e) {
        var n = $(t),
            a = n.attr("data-section-id"),
            r = n.attr("data-section-type");
        if (void 0 !== (e = e || this.constructors[r])) {
            var o = $.extend(new e(t), {
                id: a,
                type: r,
                container: t
            });
            this.instances.push(o)
        }
    },
    _onSectionLoad: function(t) {
        var e = $("[data-section-id]", t.target)[0];
        e && this._createInstance(e)
    },
    _onSectionUnload: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && ("function" == typeof e.onUnload && e.onUnload(t), this.instances = slate.utils.removeInstance(this.instances, "id", t.detail.sectionId))
    },
    _onSelect: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && "function" == typeof e.onSelect && e.onSelect(t)
    },
    _onDeselect: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && "function" == typeof e.onDeselect && e.onDeselect(t)
    },
    _onReorder: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && "function" == typeof e.onReorder && e.onReorder(t)
    },
    _onBlockSelect: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
    },
    _onBlockDeselect: function(t) {
        var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
        e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
    },
    register: function(t, e) {
        this.constructors[t] = e, $("[data-section-type=" + t + "]").each(function(t, n) {
            this._createInstance(n, e)
        }.bind(this))
    }
}), theme.ProductRecommendations = function() {
    return function(t) {
        var e = this.$container = $(t),
            n = e.data("productId"),
            a = "/recommendations/products?&section_id=product-recommendations&limit=" + e.data("limit") + "&product_id=" + n + " .product-recommendations";
        e.parent().load(a)
    }
}(), theme.currencySwitcher = function() {
    var t = {
            dataDiv: "#CurrencyData",
            picker: ".currency-input"
        },
        e = {};

    function n() {
        var e = $(t.picker).val();
        Currency.convertAll(Currency.currentCurrency, e)
    }
    return {
        init: function() {
            var a, r = $(t.dataDiv);
            r.length && ($primaryPicker = $("#CurrencyPicker-header"), $drawerPicker = $("#CurrencyPicker-drawer"), $primaryPicker.on("change", function() {
                $drawerPicker.val($(this).val())
            }), $drawerPicker.on("change", function() {
                $primaryPicker.val($(this).val())
            }), e = {
                currency: r.data("shop-currency"),
                default: r.data("default-currency"),
                format: r.data("format"),
                moneyFormat: r.data("money-format"),
                moneyCurrencyFormat: r.data("money-currency-format")
            }, Currency.format = e.format, Currency.money_format[e.currency] = e.moneyFormat, Currency.money_with_currency_format[e.currency] = e.moneyCurrencyFormat, $("span.money span.money").each(function() {
                $(this).parents("span.money").removeClass("money")
            }), $("span.money").each(function() {
                $(this).attr("data-currency-" + e.currency, $(this).html())
            }), null == (a = Currency.cookie.read()) ? e.currency !== e.default ? Currency.convertAll(e.currency, e.default) : Currency.currentCurrency = e.default : $(t.picker).length && 0 === $(t.picker).find("option[value=" + a + "]").length ? (Currency.currentCurrency = e.currency, Currency.cookie.write(e.currency)) : a === e.currency ? Currency.currentCurrency = e.currency : Currency.convertAll(e.currency, a), $(t.picker).val(Currency.currentCurrency).on("change", n))
        },
        refresh: n,
        ajaxrefresh: function() {
            var n = $(t.picker).val();
            Currency.convertAll(e.currency, n)
        }
    }
}(), slate.Currency = function() {
    var t = "${{amount}}";
    return {
        formatMoney: function(e, n) {
            "string" == typeof e && (e = e.replace(".", ""));
            var a = "",
                r = /\{\{\s*(\w+)\s*\}\}/,
                o = n || t;

            function i(t, e, n, a) {
                if (e = slate.utils.defaultTo(e, 2), n = slate.utils.defaultTo(n, ","), a = slate.utils.defaultTo(a, "."), isNaN(t) || null == t) return 0;
                var r = (t = (t / 100).toFixed(e)).split(".");
                return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (r[1] ? a + r[1] : "")
            }
            switch (o.match(r)[1]) {
                case "amount":
                    a = i(e, 2);
                    break;
                case "amount_no_decimals":
                    a = i(e, 0);
                    break;
                case "amount_with_comma_separator":
                    a = i(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    a = i(e, 0, ".", ",")
            }
            return o.replace(r, a)
        }
    }
}(), slate.Image = function() {
    return {
        preload: function(t, e) {
            "string" == typeof t && (t = [t]);
            for (var n = 0; n < t.length; n++) {
                var a = t[n];
                this.loadImage(this.getSizedImageUrl(a, e))
            }
        },
        loadImage: function(t) {
            (new Image).src = t
        },
        imageSize: function(t) {
            var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return e ? e[1] : null
        },
        getSizedImageUrl: function(t, e) {
            if (null === e) return t;
            if ("master" === e) return this.removeProtocol(t);
            var n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (n) {
                var a = t.split(n[0]),
                    r = n[0];
                return this.removeProtocol(a[0] + "_" + e + r)
            }
            return null
        },
        removeProtocol: function(t) {
            return t.replace(/http(s)?:/, "")
        }
    }
}(), slate.Variants = function() {
    function t(t) {
        this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return t.prototype = $.extend({}, t.prototype, {
        _getCurrentOptions: function() {
            var t = $.map($(this.singleOptionSelector, this.$container), function(t) {
                var e = $(t),
                    n = e.attr("type"),
                    a = {};
                return "radio" === n || "checkbox" === n ? !!e[0].checked && (a.value = e.val(), a.index = e.data("index"), a) : (a.value = e.val(), a.index = e.data("index"), a)
            });
            return t = slate.utils.compact(t)
        },
        _getVariantFromOptions: function() {
            var t = this._getCurrentOptions(),
                e = this.product.variants,
                n = !1;
            return e.forEach(function(e) {
                var a = !0;
                t.forEach(function(t) {
                    a && (a = t.value === e[t.index])
                }), a && (n = e)
            }), n || null
        },
        _onSelectChange: function() {
            var t = this._getVariantFromOptions();
            this.$container.trigger({
                type: "variantChange",
                variant: t
            }), t && (this._updateMasterSelect(t), this._updateProdCode(t), this._updateImages(t), this._updatePrice(t), this._updateMinQty(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
        },
        _updateImages: function(t) {
            if(t.featured_image !== null) {
                $('#productThumbnails .responsive-image__wrapper[data-image-id="' + t.featured_image.id + '"]').closest('.slick-slide').click();
            }
        },
        _updatePrice: function(t) {
            this.$container.trigger({
                type: "variantPriceChange",
                variant: t
            }), 0 == $(".single-option-selector option[disabled]:selected").length && $("[data-price-wrapper]").show()
        },
        _updateHistoryState: function(t) {
            if (history.replaceState && t) {
                var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                window.history.replaceState({
                    path: e
                }, "", e)
            }
        },
        _updateMasterSelect: function(t) {
            if ($("#productFormId", this.$container)[0] != undefined) {
                $("#productFormId", this.$container)[0].value = t.id;
            }
        },
        _updateProdCode: function(t) {
            $("[data-product-sku]").each(function() {
                $(this).text(t.sku)
            })
        },
        _updateMinQty: function(t) {
            var e = parseInt($("span[data-default]").text());
            $("#variantAmounts span").each(function() {
                var n = t.name,
                    a = (n = n.split("- "))[1];
                if (a.toLowerCase().indexOf(" / ") >= 0) {
                    var r = a.split(" / ");
                    for (let t = 0; t < r.length; t++) {
                        const e = r[t];
                        e.toLowerCase().indexOf("mm") >= 0 && (a = e)
                    }
                }
                a == $(this).data("variant-name") && (e = parseInt($(this).text()))
            }), $(".updateVariantQty").each(function() {
                1 == e ? $("#productPageAlert").hide() : ($("#productPageAlert").show(), $(this).text(e))
            }), $('input[name="quantity"]').attr("min", e).attr("value", e).val(e)
        }
    }), t
}(), theme.Product = function() {
    var t = {
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        addToCartBuyNowText: "[data-add-to-cart-buy-now-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productFeaturedImage: "[data-product-featured-image]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        productPriceVat: "[data-product-price-vat]",
        productThumbs: "[data-product-single-thumbnail]",
        singleOptionSelector: "[data-single-option-selector]"
    };

    function e(e) {
        if (this.$container = $(e), $(t.productJson, this.$container).html()) {
            this.$container.attr("data-section-id");
            this.productSingleObject = JSON.parse($(t.productJson, this.$container).html());
            var n = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || !1,
                singleOptionSelector: t.singleOptionSelector,
                originalSelectorId: t.originalSelectorId,
                product: this.productSingleObject
            };
            this.settings = {}, this.namespace = ".product", this.variants = new slate.Variants(n), this.$featuredImage = $(t.productFeaturedImage, this.$container), this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)), this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this)), this.$featuredImage.length > 0 && (this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src")), slate.Image.preload(this.productSingleObject.images, this.settings.imageSize), this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this)))
        }
    }
    return e.prototype = $.extend({}, e.prototype, {
        updateAddToCartState: function(e) {
            var n = e.variant;
            if (!n) return $(t.addToCart, this.$container).prop("disabled", !0), $(t.addToCartText, this.$container).html(theme.strings.unavailable), $(t.addToCartBuyNowText, this.$container).html("Unavilable"), void $(t.priceWrapper, this.$container).addClass("d-none");
            $(t.priceWrapper, this.$container).removeClass("d-none"), n.available ? ($(t.addToCart, this.$container).prop("disabled", !1), $(t.addToCartText, this.$container).html(theme.strings.addToCart), $(t.addToCartBuyNowText, this.$container).html("Buy Now")) : ($(t.addToCart, this.$container).prop("disabled", !0), $(t.addToCartText, this.$container).html(theme.strings.soldOut), $(t.addToCartBuyNowText, this.$container).html("Sold Out"))
        },
        updateProductPrices: function(e) {
            var n = e.variant,
                a = $(t.comparePrice, this.$container),
                r = a.add(t.comparePriceText, this.$container);
                var incVat = $('<span />').addClass('vat-text').html(" (inc VAT)");
                var exVat = $('<span />').addClass('vat-text').html(" (ex VAT)");
            $(t.productPrice, this.$container).html("Only " + slate.Currency.formatMoney(n.price, theme.moneyFormat)).append(incVat), $(t.productPriceVat, this.$container).html(slate.Currency.formatMoney(n.price / 1.2, theme.moneyFormat)).append(exVat), n.compare_at_price > n.price ? (a.html(slate.Currency.formatMoney(n.compare_at_price, theme.moneyFormat)), r.removeClass("d-none")) : (a.html(""), r.addClass("d-none"))
        },
        updateProductImage: function(t) {},
        onUnload: function() {
            this.$container.off(this.namespace)
        }
    }), e
}(), theme.customerAddresses = function() {
    var t = $("#AddressNewForm");
    t.length && ($(".address-country-option").each(function() {
        var t = $(this).data("form-id"),
            e = "AddressCountry_" + t,
            n = "AddressProvince_" + t,
            a = "AddressProvinceContainer_" + t;
        new Shopify.CountryProvinceSelector(e, n, {
            hideElement: a
        })
    }), $(".address-new-toggle").on("click", function() {
        t.toggleClass("d-none")
    }), $(".address-edit-toggle").on("click", function() {
        var t = $(this).data("form-id");
        $("#EditAddress_" + t).toggleClass("d-none")
    }), $(".address-delete").on("click", function() {
        var t = $(this),
            e = t.data("form-id"),
            n = t.data("confirm-message");
        confirm(n || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + e, {
            parameters: {
                _method: "delete"
            }
        })
    }))
}(), theme.customerLogin = function() {
    var t = "#RecoverPassword",
        e = "#HideRecoverPasswordLink";

    function n(t) {
        t.preventDefault(), a()
    }

    function a() {
        $("#RecoverPasswordForm").toggleClass("d-none"), $("#CustomerLoginForm").toggleClass("d-none")
    }
    $(t).length && ("#recover" === window.location.hash && a(), function() {
        if (!$(".reset-password-success").length) return;
        $("#ResetSuccess").removeClass("d-none")
    }(), $(t).on("click", n), $(e).on("click", n))
}(), $(document).ready(function() {
    var t = new slate.Sections;
    t.register("product", theme.Product), t.register("product-recommendations", theme.ProductRecommendations), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(t) {
        slate.a11y.pageLinkFocus($(t.currentTarget.hash))
    });
    slate.rte.wrapTable({
        $tables: $(".rte table"),
        tableWrapperClass: "rte__table-wrapper"
    }), slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
});